import type { ReactNode } from 'react'
import { InfoIcon } from '@phosphor-icons/react'
import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'
import styles from './Alert.module.css'

type AlertVariant = 'info'

type AlertProps = {
  variant?: AlertVariant
  children: ReactNode
  className?: string
}

export function Alert({ variant = 'info', children, className }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn(styles.alert, { [styles['alert--info']]: variant === 'info' }, className)}
    >
      <Icon as={InfoIcon} className={styles.icon} />
      <span className={styles.content}>{children}</span>
    </div>
  )
}
